import sanitizeHtml from 'sanitize-html';

const setHtml = (html: string): Record<string, unknown> => {
  return {
    dangerouslySetInnerHTML: {
      __html: sanitizeHtml(html, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(['span', 'center']),
        allowedAttributes: {
          ...sanitizeHtml.defaults.allowedAttributes,
          span: ['class'],
        },
      }),
    },
  };
};

export default setHtml;
